import i18n from '@/lib/i18n';

const state = {
  locale: null,
  translations: {}
};

const mutations = {
  SET_LOCALE(state, locale) {
    state.locale = locale;
  },
  SET_TRANSLATIONS(state, translations) {
    state.translations = translations;
  }
};

const i18nLocale = locale => {
  switch (locale) {
    case 'ko-KR':
      return 'ko';
    case 'en-US':
      return 'en';
    case 'ja-JP':
      return 'ja';
    default:
      return locale;
  }
};

const actions = {
  fetchTranslations({ rootState, commit }, locale) {
    rootState.api.fetchTranslations(locale).then(({ data }) => {
      commit('SET_LOCALE', data.locale);
      commit('SET_TRANSLATIONS', data.translations);
      i18n.locale = i18nLocale(data.locale);
    });
  }
};

export default { namespaced: true, state, mutations, actions };
